import { render, staticRenderFns } from "./AwardDetail.vue?vue&type=template&id=d2a2477e&scoped=true&"
import script from "./AwardDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardDetail.vue?vue&type=style&index=0&id=d2a2477e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a2477e",
  null
  
)

export default component.exports